
import AppForm from './Components/form';

export default function App() {

    return (
        <AppForm />
    );
}
